import React, { useEffect, useState } from 'react'
import TitleCard from '../components/TitleCard'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faFloppyDisk, faCopy, faCirclePlus } from '@fortawesome/free-solid-svg-icons'

import Select from 'react-select'

import { useHistory, useParams } from 'react-router-dom'

import ScheduleSlotEditor from '../components/ScheduleSlotEditor'
import {
  DEFAULT_SLOT,
  legacyToNew,
  stripUiFlags,
  validateSlot,
} from '../components/scheduleSlot'

function CustomerNew(props) {
  const [name, setName] = useState('')
  const [vat, setVat] = useState('')
  const [address, setAddress] = useState('')
  const [deliveryTime, setDeliveryTime] = useState(new Date())
  const [closure, setClosure] = useState(new Date())
  // Il prezzo è memorizzato lato DB come intero in centesimi (es. 1500 = 15€).
  // Lo state qui è in EURO come stringa (es. "15.00") per coerenza con la UI
  // e con la dashboard analytics che mostra euro. Conversioni:
  //   load (centesimi → euro): cents / 100
  //   save (euro → centesimi): Math.round(parseFloat(euro) * 100)
  const [price, setPrice] = useState('15.00')
  const [enabled, setEnambled] = useState(false)
  const [hasSchedule, setHasSchedule] = useState(false)
  const [schedule, setSchedule] = useState([])

  const [menu, setMenu] = useState({ label: '', value: '' })
  const [menus, setMenus] = useState([])
  const { id } = useParams()
  const history = useHistory()
  useEffect(() => {
    if (id !== 'new') {
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append(
        'x-auth-token',
        localStorage.getItem('cut-catering-token'),
      )

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      }

      fetch('https://app.cutcatering.it/api/customers/' + id, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          setName(result.name)
          setVat(result.vat)
          setAddress(result.address)
          setDeliveryTime(new Date(result?.deliveryTime))
          setClosure(new Date(result.closure))
          setPrice(((Number(result.price) || 0) / 100).toFixed(2))
          setEnambled(result.enabled)
          setHasSchedule(result.hasSchedule || false)
          setMenu({ label: result.menuName, value: result.menu })
          setSchedule((result.schedule || []).map(legacyToNew))
        })
        .catch(error => console.log('error', error))
    }
  }, [id])

  useEffect(() => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('x-auth-token', localStorage.getItem('cut-catering-token'))

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    }

    fetch('https://app.cutcatering.it/api/menus/', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        setMenus(
          result
            .filter(e => !e?.hidden)
            .map(m => ({ label: m.name, value: m._id })),
        )
      })
      .catch(error => console.log('error', error))
  }, [])

  const toggleSchedule = () => {
    if (!hasSchedule && !schedule.length) setSchedule([{ ...DEFAULT_SLOT }])
    setHasSchedule(!hasSchedule)
  }

  const scheduleHasErrors = hasSchedule
    ? schedule.some(s => validateSlot(s).length > 0)
    : false

  return (
    <div className="dashboard-container">
      <div className="column">
        <TitleCard
          title={id !== 'new' ? `Cliente: ${name}` : 'Nuovo cliente'}
          subtitle={`Inserisci le informazioni richieste e seleziona il menu!`}
        />
      </div>
      <div className="new-menu-card">
        <div className="toggle-input-row">
          <span className="nome-title-sec">Nome</span>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div className="toggle-input-row">
          <span className="nome-title-sec">VAT</span>
          <input
            type="text"
            value={vat}
            onChange={e => setVat(e.target.value)}
          />
        </div>
        <div className="toggle-input-row">
          <span className="nome-title-sec">Indirizzo</span>
          <input
            type="text"
            value={address}
            onChange={e => setAddress(e.target.value)}
          />
        </div>
        <div className="toggle-input-row">
          <span className="nome-title-sec">Prezzo (€)</span>
          <input
            type="number"
            step="0.01"
            min="0"
            inputMode="decimal"
            placeholder="15.00"
            value={price}
            onChange={e => setPrice(e.target.value)}
          />
        </div>
        <div className="toggle-input-row">
          <span className="nome-title-sec">Ripetitivo</span>
          <input
            type="checkbox"
            checked={hasSchedule}
            onChange={e => toggleSchedule()}
          />
        </div>
        {hasSchedule ? (
          <div className="schedule-container">
            {schedule.some(s => s._legacyImported) && (
              <div className="schedule-legacy-banner">
                ⚠ Configurazione importata dal vecchio formato (orari basati su
                ore-prima-della-consegna). Verifica i valori e salva per
                migrare al nuovo formato Europe/Rome.
              </div>
            )}
            {schedule.map((slot, key) => (
              <ScheduleSlotEditor
                key={key}
                slot={slot}
                index={key}
                menus={menus}
                onChange={updated => {
                  const next = [...schedule]
                  next[key] = updated
                  setSchedule(next)
                }}
                onRemove={() => {
                  const next = schedule.slice()
                  next.splice(key, 1)
                  setSchedule(next)
                }}
              />
            ))}
            <div
              className="add-new-day-schedule"
              onClick={() => {
                if (!schedule.length) {
                  setSchedule([{ ...DEFAULT_SLOT }])
                } else {
                  const last = schedule[schedule.length - 1]
                  const nextWeekday = Math.min(6, (last.weekday ?? 1) + 1)
                  setSchedule([
                    ...schedule,
                    { ...DEFAULT_SLOT, ...last, weekday: nextWeekday },
                  ])
                }
              }}
            >
              <FontAwesomeIcon icon={faPlus} /> Aggiungi Giorno
            </div>
          </div>
        ) : (
          <>
            <div className="toggle-input-row">
              <span className="nome-title-sec">Momento consegna</span>
              <input
                type="datetime-local"
                value={getTrimmedDate(deliveryTime)}
                onChange={e => setDeliveryTime(getNewDate(e.target.value))}
              />
            </div>
            <div className="toggle-input-row">
              <span className="nome-title-sec">Momento chiusura ordini</span>
              <input
                type="datetime-local"
                value={getTrimmedDate(closure)}
                onChange={e => {
                  let newDate = getNewDate(e.target.value)
                  setClosure(newDate)
                  let deliveryTime2 = new Date(deliveryTime)
                  deliveryTime2.setFullYear(newDate.getFullYear())
                  deliveryTime2.setMonth(newDate.getMonth())
                  deliveryTime2.setDate(newDate.getDate())
                  setDeliveryTime(deliveryTime2)
                }}
              />
            </div>

            <div className="new-allergene-item menu-inline-selection">
              <span className="section-title-span">Menu: </span>
              <span className="section-select-span">
                <Select
                  value={menu}
                  onChange={e => {
                    setMenu(e)
                  }}
                  options={menus}
                />
              </span>
            </div>
          </>
        )}
        {id !== 'new' ? (
          <div className="header-add">
            <div
              className={`card-button card-button-primary${
                scheduleHasErrors ? ' card-button-disabled' : ''
              }`}
              onClick={() => {
                if (scheduleHasErrors) return
                var myHeaders = new Headers()
                myHeaders.append('Content-Type', 'application/json')
                myHeaders.append(
                  'x-auth-token',
                  localStorage.getItem('cut-catering-token'),
                )

                fetch('https://app.cutcatering.it/api/customers/' + id, {
                  method: 'POST',
                  headers: myHeaders,
                  body: JSON.stringify({
                    name,
                    vat,
                    address,
                    menu: menu.value,
                    menuName: menu.label,
                    deliveryTime,
                    closure,
                    price: Math.round((parseFloat(price) || 0) * 100),
                    enabled,
                    hasSchedule,
                    schedule: schedule.map(stripUiFlags),
                  }),
                  redirect: 'follow',
                })
                  .then(response => response.text())
                  .then(result => {
                    console.log(result)
                    history.push('/customers')
                  }) //()
                  .catch(error => console.log('error', error))
              }}
            >
              <FontAwesomeIcon icon={faFloppyDisk} /> Salva modifiche
            </div>
            <div
              className={`card-button card-button-secondary${
                scheduleHasErrors ? ' card-button-disabled' : ''
              }`}
              title="Crea un nuovo cliente con questi stessi dati, lasciando intatto l'attuale"
              onClick={() => {
                if (scheduleHasErrors) return
                var myHeaders = new Headers()
                myHeaders.append('Content-Type', 'application/json')
                myHeaders.append(
                  'x-auth-token',
                  localStorage.getItem('cut-catering-token'),
                )

                fetch('https://app.cutcatering.it/api/customers/', {
                  method: 'POST',
                  headers: myHeaders,
                  body: JSON.stringify({
                    name,
                    vat,
                    address,
                    menu: menu.value,
                    menuName: menu.label,
                    deliveryTime,
                    closure,
                    price: Math.round((parseFloat(price) || 0) * 100),
                    enabled,
                    hasSchedule,
                    schedule: schedule.map(stripUiFlags),
                  }),
                  redirect: 'follow',
                })
                  .then(response => response.text())
                  .then(result => {
                    console.log(result)
                    history.push('/customers')
                  }) //()
                  .catch(error => console.log('error', error))
              }}
            >
              <FontAwesomeIcon icon={faCopy} /> Duplica come nuovo cliente
            </div>
          </div>
        ) : (
          <div className="header-add">
            <div
              className={`card-button card-button-primary${
                scheduleHasErrors ? ' card-button-disabled' : ''
              }`}
              onClick={() => {
                if (scheduleHasErrors) return
                var myHeaders = new Headers()
                myHeaders.append('Content-Type', 'application/json')
                myHeaders.append(
                  'x-auth-token',
                  localStorage.getItem('cut-catering-token'),
                )

                fetch('https://app.cutcatering.it/api/customers', {
                  method: 'POST',
                  headers: myHeaders,
                  body: JSON.stringify({
                    name,
                    vat,
                    address,
                    menu: menu.value,
                    menuName: menu.label,
                    deliveryTime,
                    closure,
                    price: Math.round((parseFloat(price) || 0) * 100),
                    enabled,
                    hasSchedule,
                    schedule: schedule.map(stripUiFlags),
                  }),
                  redirect: 'follow',
                })
                  .then(response => response.text())
                  .then(result => {
                    console.log(result)
                    history.push('/customers')
                  }) //()
                  .catch(error => console.log('error', error))
              }}
            >
              <FontAwesomeIcon icon={faCirclePlus} /> Crea cliente
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

function getTrimmedDate(date) {
  let date3 = new Date(date)
  let date2 = new Date()
  date3.setMinutes(-date2.getTimezoneOffset())
  let date1 = date3.toISOString().split(':')
  date1.splice(-1)
  return date1.join(':')
}

function getNewDate(date) {
  let date3 = new Date(date + ':00.000Z')
  let date2 = new Date()
  date3.setMinutes(date2.getTimezoneOffset())
  return date3
}

export default CustomerNew
